
import './App.css';
import { router, } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React from 'react'
import { InstallPromptProvider } from './Components/InstallApp/useInstallPrompt';


function App() {


  return (

    <InstallPromptProvider>
      <RouterProvider router={router} />
    </InstallPromptProvider>

  );
}

export default App;
